import { render, staticRenderFns } from "./ProcurementSalesConfirmation.vue?vue&type=template&id=55f1a23b"
import script from "./ProcurementSalesConfirmation.vue?vue&type=script&lang=js"
export * from "./ProcurementSalesConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports